import { render } from "./VideosPlaylist.vue?vue&type=template&id=74d9ce0c&scoped=true&ts=true"
import script from "./VideosPlaylist.vue?vue&type=script&lang=ts"
export * from "./VideosPlaylist.vue?vue&type=script&lang=ts"

import "./VideosPlaylist.vue?vue&type=style&index=0&id=74d9ce0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d9ce0c"]])

export default __exports__